/* global __BUILD_ID__ */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    supportedLngs: ['es', 'en', 'it', 'sv', 'fr', 'nl'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'level_lang',
    },
    backend: {
      // ?v=<build>: ver __BUILD_ID__ en vite.config.js
      loadPath: `/locales/{{lng}}/translation.json?v=${__BUILD_ID__}`,
    },
    interpolation: {
      escapeValue: false,
    },
  })

// <html lang> con el idioma que se ve de verdad: si no, el navegador cree que
// está en español y se ofrece a traducirla
const setLang = (lng) => { if (lng) document.documentElement.lang = lng.split('-')[0] }
i18n.on('languageChanged', setLang)
setLang(i18n.resolvedLanguage || i18n.language)

export default i18n